// extracted by mini-css-extract-plugin
export default {"ripple":"ripple__Do-Zd","rippleContainer":"rippleContainer__gtc3I","rippleSpan":"rippleSpan__vbLWZ"};